import React from 'react';
import { Modal, Form, Button, Spinner } from '@themesberg/react-bootstrap'
import { StyledSelect } from '../style'




function AssignCategoryModal({ options, handleUpdateCategoryChange, selectedCategoryOption, showModal, onHide, onSubmitAddCasinoGameCategory, loading, isEnanbleAssignCategory }) {
  return (
    <Modal show={showModal} onHide={onHide}>
      {/* closeButton */}
      <Modal.Header closeButton>
        <Modal.Title>Casino category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          <div className="d-flex flex-column gap-3">
            {options?.length > 0 ? <Form.Group>
              <Form.Label>Casino category</Form.Label>
              <StyledSelect
                value={selectedCategoryOption}
                onChange={handleUpdateCategoryChange}
              >
                <option value="">Select Casino category</option>
                {options?.map(
                  ({ label, value }) => (
                    <option
                      key={label}
                      value={value}
                    >
                      {label}
                    </option>
                  )
                )}
              </StyledSelect>
            </Form.Group> : ""}

          </div>
        </>

      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
        // disabled={updatingStatus}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onSubmitAddCasinoGameCategory}
          disabled={!selectedCategoryOption || !isEnanbleAssignCategory?.enable}

        >
          {loading ? "Updating..." : "Save Changes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AssignCategoryModal;